import { render, staticRenderFns } from "./BInputGroupFormSelect.vue?vue&type=template&id=60863f68&"
import script from "./BInputGroupFormSelect.vue?vue&type=script&lang=js&"
export * from "./BInputGroupFormSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports